import React, { useEffect, useState } from "react";
import "./Faq.scss";
import iconAdd from "../../assets/icons/icono_agregar-mas_2.png";
import CardModal from "../../components/atoms/CardModal/CardModal";
import Input from "../../components/atoms/Input/Input";
import TextArea from "../../components/atoms/TextArea/TextArea";
import Button from "../../components/atoms/Button/Button";
import ValidationMessage from "../../components/atoms/ValidationMessage/ValidationMessage";
import { validateData } from "../../utiles/ValidateEntries";
import { resources } from "../../services/resources";
import { toast, Toaster } from "sonner";
const Faq = () => {
    const [formModal, setFormModal] = useState(false);

    const [faq, setFaq] = useState({
        question: "",
        answer: "",
    });

    const [faqAll, setFaqAll] = useState([]);

    const [emptyField, setEmptyField] = useState({});

    const handleChangeDatas = (e) => {
        const { name, value } = e.currentTarget;
        setFaq((prevent) => ({
            ...prevent,
            [name]: value,
        }));

        setEmptyField((prev) => ({
            ...prev,
            [name]: false,
        }));
    };

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            const { status, emptyFields } = validateData(faq);

            // Guardar los campos vacíos en el estado
            setEmptyField(emptyFields);

            if (!status) {
                console.error(
                    "Por favor, completa todos los campos requeridos."
                );
                return;
            }

            const toast_id = toast("Procesando...");

            const response = await resources.createQuestion(faq);

            if (!response.success && response.requestCode === 409) {
                toast.error("¡Ups!", {
                    description: "La pregunta ya existe, intenta con otra.",
                    position: "top-right",
                    duration: 5000,
                    icon: "⭕️",
                    id: toast_id,
                });

                return;
            }

            toast.success("Exito!", {
                description: response.message,
                position: "top-right",
                duration: 5000,
                icon: "✅",
                id: toast_id,
            });

            setFaqAll((prev) => [...prev, faq]);

            setFormModal(false);
            setFaq({
                question: "",
                answer: "",
            });
        } catch (error) {}
    };

    useEffect(() => {
        if (!formModal) {
            setFaq({
                question: "",
                answer: "",
            });
        }
    }, [formModal]);

    const getFaqs = async () => {
        try {
            const response = await resources.getFaqs();
            if (response.success) {
                setFaqAll(response.data);
            } else {
                console.error(
                    "Error al obtener las preguntas frecuentes:",
                    response.message
                );
            }
        } catch (error) {
            console.error(
                "Error en la solicitud de preguntas frecuentes:",
                error
            );
        }
    };

    useEffect(() => {
        getFaqs();
    }, []);

    return (
        <>
            <div className="titulo">PREGUNTAS FRECUENTES</div>
            <div className="contenedorDeProguntas">
                <div className="contenedor">
                    <div className="tituloPregunta centrar">
                        {"Agregar Pregunta"}
                    </div>
                    <div className="respuesta centrar">
                        <img
                            onClick={() => {
                                setFormModal(true);
                            }}
                            style={{ cursor: "pointer" }}
                            src={iconAdd}
                            alt=""
                        />
                    </div>
                    {faqAll.map((item, key) => {
                        return (
                            <>
                                {key <= (faqAll.length - 1) / 2 ? (
                                    <>
                                        <div className="tituloPregunta">
                                            {item.question}
                                        </div>
                                        <div className="respuesta">
                                            {item.answer}
                                        </div>
                                    </>
                                ) : (
                                    ""
                                )}
                            </>
                        );
                    })}
                </div>
                <div className="contenedor">
                    {faqAll.map((item, key) => {
                        return (
                            <>
                                {key >= (faqAll.length - 1) / 2 ? (
                                    <>
                                        <div className="tituloPregunta">
                                            {item.question}
                                        </div>
                                        <div className="respuesta">
                                            {item.answer}
                                        </div>
                                    </>
                                ) : (
                                    ""
                                )}
                            </>
                        );
                    })}
                </div>
            </div>

            {formModal && (
                <CardModal
                    setStatusModal={setFormModal}
                    className={"customModal"}
                >
                    <h4 className="customModal__title">Nueva pregunta</h4>
                    <form onSubmit={handleSubmit} className="customModal__form">
                        <ValidationMessage show={emptyField.question}>
                            <Input
                                type="text"
                                // text={"Pregunta"}
                                placeholder={"Pregunta"}
                                name={"question"}
                                onChange={handleChangeDatas}
                                show={emptyField.question}
                                className="customModal__form__input"
                            />
                        </ValidationMessage>
                        <ValidationMessage show={emptyField.answer}>
                            <TextArea
                                name={"answer"}
                                placeholder={"Respuesta"}
                                onChange={handleChangeDatas}
                                // text={"Respuesta"}
                                show={emptyField.answer}
                            />
                        </ValidationMessage>
                        <div className="customModal__form__butons">
                            <Button
                                text={"Guardar"}
                                type={"submit"}
                                className="degrad customModal__form__butons__btn"
                            />
                        </div>
                    </form>
                </CardModal>
            )}

            <Toaster />
        </>
    );
};
export default Faq;
